import styled, { createGlobalStyle } from 'styled-components';
import { theme } from './Theme';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${theme.colors.secondary}; /* Default background */
    color: ${theme.colors.textPrimary}; /* Default text color */
    font-family: ${theme.fonts.main};
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  h1 {
    font-size: 2.5rem;
  }
  p {
    font-size: 1rem;
  }
  button {
    font-size: 1rem;
    padding: 10px 20px;
  }

  /* Responsive Styles */
  ${theme.responsive.mobile}

  ${theme.responsive.tablet}

  ${theme.responsive.desktop}
`;

export default GlobalStyle;
